export default __webpack_public_path__ + "static/media/pooni-rice.8f576591.jpg";